export const task = {
  index: {
    title: 'Tasks'
  },

  field: {
    id: 'ID',
    number: 'Nomor',
    caller_id: 'Caller ID',
    priority: 'Prioritas',
    attempts: 'Posisi dalam strategi',
    strategy: 'Posisi dalam strategi',
    start: 'Perintah dibuat di',
    status: 'Keadaan',
    last_attempt: 'Percobaan terakhir',
    next_attempt: 'Percobaan berikutnya',
    created_at: 'Perintah dibuat di',
    lead_date: 'Tugas dibuat di',
    delayed_until: 'Tertunda sampai',
    additionally: 'Selain itu'
  },

  state: {
    title: 'Keadaan',
    success: 'Berhasil',
    processing: 'Proses',
    canceled: 'Dibatalkan',
    pending: 'Tunda',
    fail: 'Gagal'
  },

  tooltips: {
    strategy:
      'Nilai yang ditentukan akan menentukan dari tahap strategi apa usaha panggilan akan dilakukan.',
    caller_id:
      'Jika bidang dibiarkan kosong, tugas akan diberi ID Penelepon yang ditentukan saat membuat kampanye.',
    delayed_until: 'Waktu dalam UTC +00:00',
    additionally:
      'Bidang tersebut mewakili informasi tambahan apa pun yang akan diteruskan ke hook.'
  },
  
  warnings: {
    skills:
      'Keterampilan operator tidak akan diperhitungkan. Opsi "Pertimbangkan keterampilan operator" tidak dipilih dalam pengaturan kampanye.'
  },

  button: {
    create: 'Buat tugas'
  },

  modal: {
    create: 'Buat tugas',
    import: 'Impor tugas',
    import_hint: 'Pastikan nomor dalam file dalam format internasional. Misalnya, +7ХХХХХХХХХ.'
  }
};
